import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    handleCallback();
  }, []);

  const handleCallback = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');

      const savedState = sessionStorage.getItem('auth_state');

      if (!code || !state || state !== savedState) {
        throw new Error('Invalid authentication response');
      }

      const response = await authAPI.login(code, state);
      login(response.data);

      sessionStorage.removeItem('auth_state');
      navigate('/dashboard');
    } catch (error) {
      console.error('Authentication failed:', error);

      // Check if it's an access denied error
      if (error.response?.status === 403) {
        alert(error.response.data.message || 'Bu sisteme giriş yetkiniz yok.');
      }

      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Giriş yapılıyor...</p>
      </div>
    </div>
  );
};

export default AuthCallback;